<div class="pos-relative">
    <ng-content />
    <button class="pos-absolute right-0 bottom-0 z-1 flex flex-middle p-r cursor-pointer toggle-password"
            type="button"
            (click)="toggle()">
        <span class="fs-3 bg-col-w">{{isPasswordType ? 'Show' : 'Hide'}}</span>
    </button>
</div>